function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './order-details.scss';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useForm } from 'react-hook-form';

// import AdminActionsPanel from 'shared/components/AdminActionsPanel';
import Loading from 'researcher/components/Loading';
import useRepeater from 'researcher/hooks/use-repeater';
import { useFormHelpers } from 'shared/helper/form';
import { Files as FileUploads, Questions } from 'researcher/service-details';
import PostMount from 'shared/components/PostMount';
import { T } from 'shared/helper/translate';
import { convertFormDataToOrderUpdateRequest, convertJsonToFormData } from 'shared/view/order-conversion-service';
import useOrderDetailsForm from './use-order-details-form';
import OrderDetailsWrapper from './OrderDetailsWrapper';
import OrderPanelHeader from './OrderPanelHeader';
import OrderDetailsSidebar from './OrderDetailsSidebar';
import OrderDetailsContent from './OrderDetailsContent';
var defaultValues = {
  answers: {},
  deadline: '',
  files: {},
  journal: {
    name: '',
    url: '',
    valid: true
  },
  services: [],
  styleOfEnglish: '',
  title: ''
};

// Try to load our order for two minutes
var NUMBER_OF_SECONDS_BETWEEN_CALLS = 3;
var NUMBER_OF_TIMES_TO_EXECUTE = 4 * 60 / NUMBER_OF_SECONDS_BETWEEN_CALLS;
var OrderDetails = function OrderDetails(_ref) {
  var addMessage = _ref.addMessage,
    displayInvoices = _ref.displayInvoices,
    displayJournal = _ref.displayJournal,
    displayPreprintCampaign = _ref.displayPreprintCampaign,
    excludedFileTypes = _ref.excludedFileTypes,
    externalId = _ref.externalId,
    fetchOrderCertificate = _ref.fetchOrderCertificate,
    fetchOrders = _ref.fetchOrders,
    fetchUserRewardPoints = _ref.fetchUserRewardPoints,
    getDownloadUrl = _ref.getDownloadUrl,
    showStyleOfEnglish = _ref.showStyleOfEnglish,
    loadNumberOfOrders = _ref.loadNumberOfOrders,
    loadPaymentInformation = _ref.loadPaymentInformation,
    loadServices = _ref.loadServices,
    newOrder = _ref.newOrder,
    order = _ref.order,
    reeditMessageTerm = _ref.reeditMessageTerm,
    returnUrl = _ref.returnUrl,
    saveOrder = _ref.saveOrder,
    siteLanguage = _ref.siteLanguage,
    status = _ref.status,
    updateCertificate = _ref.updateCertificate,
    updateEmailNotificationSettings = _ref.updateEmailNotificationSettings,
    userHasRewards = _ref.userHasRewards,
    userIdentity = _ref.userIdentity;
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var _methods$watch = methods.watch(['deadline', 'services']),
    _methods$watch2 = _slicedToArray(_methods$watch, 2),
    deadline = _methods$watch2[0],
    _methods$watch2$ = _methods$watch2[1],
    services = _methods$watch2$ === void 0 ? [] : _methods$watch2$;
  var _useFormHelpers = useFormHelpers(methods),
    preprocessData = _useFormHelpers.preprocessData,
    populateFormData = _useFormHelpers.populateFormData;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    editingOrderDetails = _useState2[0],
    setEditingOrderDetails = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    savingOrder = _useState4[0],
    setSavingOrder = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    orderNotFound = _useState6[0],
    setOrderNotFound = _useState6[1];
  var _useState7 = useState(!userHasRewards),
    _useState8 = _slicedToArray(_useState7, 2),
    userRewardPointsUpdated = _useState8[0],
    setUserRewardPointsUpdated = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    serviceDetailsUpdating = _useState10[0],
    setServiceDetailsUpdating = _useState10[1];
  var _useState11 = useState(newOrder),
    _useState12 = _slicedToArray(_useState11, 2),
    waitForTransaction = _useState12[0],
    setWaitForTransaction = _useState12[1];
  var populateOrderDetails = function populateOrderDetails(order) {
    return populateFormData(convertJsonToFormData(order));
  };
  var updateDeadline = function updateDeadline(deadline) {
    return methods.setValue('deadline', deadline);
  };
  var _useOrderDetailsForm = useOrderDetailsForm({
      updateDeadline: updateDeadline,
      getOrder: function getOrder() {
        return order;
      },
      getNewServices: function getNewServices(newServiceIdentities) {
        return methods.getValues('services').filter(function (service) {
          return newServiceIdentities.indexOf(service.serviceIdentity) !== -1;
        });
      }
    }),
    newDeadline = _useOrderDetailsForm.newDeadline,
    newServiceIdentities = _useOrderDetailsForm.newServiceIdentities,
    onServiceAdded = _useOrderDetailsForm.onServiceAdded,
    onServiceRemoved = _useOrderDetailsForm.onServiceRemoved,
    resetOrderDetailsProperties = _useOrderDetailsForm.resetOrderDetailsProperties;
  var _useRepeater = useRepeater({
      fn: function fn() {
        return fetchOrders({
          xid: externalId
        });
      },
      onNumberOfExecutionsExceeded: function onNumberOfExecutionsExceeded() {
        return setOrderNotFound(true);
      },
      numberOfSecondsBetweenCalls: NUMBER_OF_SECONDS_BETWEEN_CALLS,
      numberOfTimesToExecute: NUMBER_OF_TIMES_TO_EXECUTE
    }),
    tryToLoadOrder = _useRepeater.start,
    stopAttemptingToLoadOrder = _useRepeater.stop;
  var _useRepeater2 = useRepeater({
      fn: function fn() {
        fetchUserRewardPoints({
          externalId: externalId,
          userIdentity: userIdentity
        }).then(function (updated) {
          setUserRewardPointsUpdated(updated);
        });
      },
      onNumberOfExecutionsExceeded: function onNumberOfExecutionsExceeded() {
        return setUserRewardPointsUpdated(true);
      },
      numberOfSecondsBetweenCalls: NUMBER_OF_SECONDS_BETWEEN_CALLS,
      numberOfTimesToExecute: NUMBER_OF_TIMES_TO_EXECUTE
    }),
    startFetchingUserRewardPoints = _useRepeater2.start,
    stopFetchingUserRewardPoints = _useRepeater2.stop;
  var cancelEdit = function cancelEdit() {
    setEditingOrderDetails(false);
    methods.reset(defaultValues);
  };
  var handleSubmit = function handleSubmit(data) {
    setSavingOrder(true);
    saveOrder(data).then(function () {
      setEditingOrderDetails(false);
      setSavingOrder(false);
    });
  };
  var editOrder = function editOrder() {
    resetOrderDetailsProperties(order);
    setEditingOrderDetails(true);
    populateOrderDetails(order);
    loadServices(order.externalId);
  };
  var loadOrderDetails = function loadOrderDetails() {
    loadNumberOfOrders(userIdentity, false);
  };
  useEffect(function () {
    setWaitForTransaction(newOrder);
    if (!order) {
      tryToLoadOrder();
    }
  }, []);
  useEffect(function () {
    if (!order || order.rewardPoints === 0 && userHasRewards) {
      return;
    }
    stopAttemptingToLoadOrder();
    if (waitForTransaction) {
      if (userHasRewards) {
        startFetchingUserRewardPoints();
      }
      loadPaymentInformation(externalId, newOrder).then(function () {
        setWaitForTransaction(false);
      });
    }
  }, [order === null || order === void 0 ? void 0 : order.rewardPoints]);
  useEffect(function () {
    if (!userRewardPointsUpdated) {
      return;
    }
    stopFetchingUserRewardPoints();
  }, [userRewardPointsUpdated]);
  if (orderNotFound) {
    return /*#__PURE__*/React.createElement(OrderDetailsWrapper, {
      methods: methods,
      returnUrl: returnUrl,
      title: externalId
    }, /*#__PURE__*/React.createElement("div", {
      className: "row order-panel-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-12 order-title-wrapper"
    }, externalId)), /*#__PURE__*/React.createElement("div", {
      className: "p-4 mb-0"
    }, /*#__PURE__*/React.createElement(T.md, {
      inline: true,
      source: "load-order-failure"
    })));
  }
  if (!order || waitForTransaction || status.fetching) {
    return /*#__PURE__*/React.createElement(OrderDetailsWrapper, {
      methods: methods,
      returnUrl: returnUrl,
      title: externalId
    }, /*#__PURE__*/React.createElement("div", {
      className: "row order-panel-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-12 order-title-wrapper"
    }, externalId)), /*#__PURE__*/React.createElement(Loading, {
      text: "Please wait while we load your order"
    }));
  }
  var deadlineMismatch = newServiceIdentities.length > 0 && newDeadline && deadline && newDeadline.getTime() !== deadline.getTime();
  return /*#__PURE__*/React.createElement(OrderDetailsWrapper, {
    editingOrderDetails: editingOrderDetails,
    handleSubmit: preprocessData(convertFormDataToOrderUpdateRequest, handleSubmit),
    methods: methods,
    newOrder: newOrder,
    returnUrl: returnUrl,
    title: order.title
  }, /*#__PURE__*/React.createElement(OrderPanelHeader, {
    editingOrderDetails: editingOrderDetails,
    order: order,
    awaitingPayment: order.completed && !order.downloadAvailable
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-3 sidebar pb-4"
  }, /*#__PURE__*/React.createElement(OrderDetailsSidebar, {
    deadlineMismatch: deadlineMismatch,
    displayInvoices: displayInvoices,
    displayJournal: displayJournal,
    editingOrderDetails: editingOrderDetails,
    showStyleOfEnglish: showStyleOfEnglish,
    journalSelectionRequired: !!services.find(function (_ref2) {
      var journalDetails = _ref2.journalDetails;
      return journalDetails.required;
    }),
    methods: methods,
    newDeadline: newDeadline,
    newServiceIdentities: newServiceIdentities,
    onServiceAdded: onServiceAdded,
    onServiceRemoved: onServiceRemoved,
    order: order,
    updateDeadline: updateDeadline
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-9 details pb-4 pt-2 mb-3"
  }, /*#__PURE__*/React.createElement(PostMount, {
    action: loadOrderDetails
  }), /*#__PURE__*/React.createElement(OrderDetailsContent, {
    addMessage: addMessage,
    fetchOrderCertificate: fetchOrderCertificate,
    getDownloadUrl: getDownloadUrl,
    newOrder: newOrder,
    order: order,
    reeditMessageTerm: reeditMessageTerm,
    status: status,
    updateCertificate: updateCertificate,
    updateEmailNotificationSettings: updateEmailNotificationSettings,
    siteLanguage: siteLanguage,
    displayPreprintCampaign: displayPreprintCampaign
  }), editingOrderDetails ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement(FileUploads, {
    disabled: serviceDetailsUpdating,
    excludedFileTypes: excludedFileTypes,
    serviceIdentities: newServiceIdentities,
    methods: methods
  })), /*#__PURE__*/React.createElement(Questions, {
    methods: methods,
    onServiceDetailsUpdated: function onServiceDetailsUpdated() {
      return setServiceDetailsUpdating(false);
    },
    onServiceDetailsUpdating: function onServiceDetailsUpdating() {
      return setServiceDetailsUpdating(true);
    },
    serviceIdentities: newServiceIdentities
  }), deadlineMismatch ? /*#__PURE__*/React.createElement("div", {
    className: "alert alert-danger"
  }, /*#__PURE__*/React.createElement("strong", null, "Deadline Mismatch"), /*#__PURE__*/React.createElement("br", null), "We have calculated a deadline of ", moment(newDeadline).format('YYYY-MM-DD HH:mm'), ' ', "for the services added to this order. This deadline does not match the deadline you have supplied of ", moment(deadline).format('YYYY-MM-DD HH:mm'), ". Please double check your deadline before saving changes.") : null) : null)));
};
export default OrderDetails;